export default "__VITE_ASSET__CLLulug7__"